export const ATTESTATION_FILE_TAGS: Record<string, string> = {
  DriversLicense: "Drirver's License",
  Insurance: 'Insurance',
  ServiceRecords: 'Service Records',
};
